<template>
  <VeeField
    v-if="useCartFormData().value.invoiceAddress != null"
    v-slot="{ field, meta, errors }"
    v-model="useCartFormData().value.invoiceAddress!.street"
    name="street"
    rules="required|street|isPackstation|max:50"
  >
    <div :class="meta.touched ? (meta.valid ? 'valid' : 'invalid') : ''">
      <input
        v-bind="field"
        :class="inputClass"
        type="text"
        placeholder="Straße*"
        maxlength="50"
      >
    </div>
    <span>{{ errors[0] }}</span>
  </VeeField>
</template>
<script setup lang="ts">
import { useCartFormData } from "~/composables/states";
type InputClass = string;

defineProps({
  inputClass: {
    type: String as PropType<InputClass>,
    default: "inp sm",
  },
});
</script>
